import { takeLatest, call } from 'redux-saga/effects';
import filter from 'lodash/filter';
import { isGuestUser } from 'yoda-core-components/lib/helpers/Utils/Utils';
import { removeSavedItem } from 'yoda-interfaces/lib/SavedItems/SavedItemsApi';
import FactorySaga from 'yoda-site-components/lib/sagas/FactorySaga';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import {
    DP_CHECKOUT_SAVED_ITEMS,
    DP_CHECKOUT_SAVED_ITEMS_PAYLOAD,
} from 'yoda-site-components/lib/common/Constants';
import { ATC_REMOVE_SAVED_ITEM_REQUEST } from '../actionTypes/RemoveSavedItemActionTypes';

function doDeleteSavedItem(itemData) {
    let savedItemObj = {};
    let savedItems = [];
    if (TokenProvider.get(DP_CHECKOUT_SAVED_ITEMS)) {
        savedItemObj = JSON.parse(TokenProvider.get(DP_CHECKOUT_SAVED_ITEMS));
    }
    if (TokenProvider.get(DP_CHECKOUT_SAVED_ITEMS_PAYLOAD)) {
        savedItems = JSON.parse(TokenProvider.get(DP_CHECKOUT_SAVED_ITEMS_PAYLOAD));
    }
    if (savedItemObj && savedItemObj[itemData.ppId]) {
        delete savedItemObj[itemData.ppId];
    }
    const filteredItems = filter(
        savedItems,
        (item) => item.product.id !== itemData.ppId || item.itemId !== itemData.skuId
    );
    TokenProvider.set(DP_CHECKOUT_SAVED_ITEMS, JSON.stringify(savedItemObj));
    TokenProvider.set(DP_CHECKOUT_SAVED_ITEMS_PAYLOAD, JSON.stringify(filteredItems));
}

function* removeItemFromSFL(action) {
    const removeSflItemAction = {};
    removeSflItemAction.payload = {
        params: action.payload.itemId,
        cartSavedItems: true,
    };
    if (!isGuestUser()) {
        yield call(FactorySaga, removeSavedItem, removeSflItemAction);
    } else {
        yield call(doDeleteSavedItem, action.payload.data[0]);
    }
}

const watchRemoveSavedItem = function* watchRemoveSavedItem() {
    yield takeLatest(ATC_REMOVE_SAVED_ITEM_REQUEST, removeItemFromSFL);
};

watchRemoveSavedItem.sagaName = 'removeSavedItem';

export default watchRemoveSavedItem;
